import apiTool from './index';

const ADD_ALL_CLIENT_WINES_URL = 'clients/<pk>/all_wines/';

const GET_WINES_URL = 'wines/?no_page&limit=25&search=';
const GET_ALL_CLIENT_WINES_URL = 'clients/<pk>/all_wines/?no_page';

export default {
  addAllClientWines(payload) {
    console.log('DEBUG | wine.js | addAllClientWines');
    console.log('this is the payload that was sent');
    console.log(payload);
    return apiTool.post(
      ADD_ALL_CLIENT_WINES_URL.replace('<pk>', payload.client_id),
      payload.data
    );
  },

  getWines(payload) {
    let finalUrl = GET_WINES_URL + payload.search;

    return apiTool.get(finalUrl);
  },
  getAllClientWines(client_id) {
    return apiTool.get(GET_ALL_CLIENT_WINES_URL.replace('<pk>', client_id));
  }
};
